export function financeMoney(cents: string, currency: string) {
  const amount = BigInt(cents);
  const absolute = amount < 0n ? -amount : amount;
  const whole = new Intl.NumberFormat("tr-TR").format(absolute / 100n);
  const fraction = (absolute % 100n).toString().padStart(2, "0");
  return `${amount < 0n ? "-" : ""}${whole},${fraction} ${currency}`;
}

export function financeDay(date: string) {
  const [year, month, day] = date.split("-");
  return `${day}.${month}.${year}`;
}

export function financeTime(date: string) {
  return new Intl.DateTimeFormat("tr-TR", { timeZone: "Europe/Istanbul", hour: "2-digit", minute: "2-digit" }).format(new Date(date));
}

export function financeObservedAt(date: string) {
  return new Intl.DateTimeFormat("tr-TR", { timeZone: "Europe/Istanbul", year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit" }).format(new Date(date));
}
